export default __webpack_public_path__ + "static/media/transactional-state-provider.b61b2ff8.svg";